import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { Redirect } from 'react-router-dom';

import { useTabSettings } from 'utils/hooks/useTabSettings';
import { ROUTES } from 'utils/constants';
import heartLoader from 'assets/heart-loader.json';

import Layout from 'components/evieOnboarding/Layout';
import BottomNav from 'components/evieApp/BottomNav';
import ProgramHome from 'components/evieApp/ProgramHome';
import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';

const EvieMyProgram = () => {
  useTabSettings('Evie', '/evie-favicon.ico');
  const { loading, isPremium } = useEvieAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Program is Home for premium users; old bookmarks/links to /program should land on /home.
  if (isPremium) {
    return <Redirect to={ROUTES.EVIE_HOME} />;
  }

  return (
    <>
      <Layout>
        {!loading && <BottomNav />}
        {!loading && <ProgramHome locked />}
      </Layout>
      {loading && (
        <div className="onboarding-layout__lottie">
          <Lottie animationData={heartLoader} loop style={{ width: 140, height: 110 }} />
        </div>
      )}
    </>
  );
};

export default EvieMyProgram;
